import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseReviewLeadProps {
  establishmentLeadId?: string
  state?: string
  onSuccess?: () => void
  onError?: () => void
}

const useReviewLead = ({ establishmentLeadId, state, onSuccess, onError }: UseReviewLeadProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['reviewLead'],
    mutationFn: async (data?: { description?: string }) => {
      const lead = {
          last_review_attributes: {
          state,
          description: data?.description
        }
      }

      await privateAxios.putForm(`/funnel/establishment/leads/${establishmentLeadId}`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}

export default useReviewLead